export default __webpack_public_path__ + "static/media/banner_course_2.e0849337.png";